import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type NewTagVariant = 'sidebar' | 'dropdown';

@Component({
  selector: 'liv-new-tag',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './new-tag.component.html'
})
export class LivNewTagComponent {
  readonly variant = input<NewTagVariant>('dropdown');
}
